// Scroll naar het element van een #anker in de URL, ook als dat element er nog
// niet is omdat de pagina (lazy) nog laadt. Een gedeelde link of een "Ga naar"-
// link van Google naar een kop opende het artikel bovenaan (19-10-2026).
// Geeft een opruimfunctie terug (voor useEffect).
export function idUitHash(hash) {
  const ruw = (hash || '').replace(/^#/, '');
  if (!ruw) return '';
  try {
    return decodeURIComponent(ruw);
  } catch {
    return ruw;
  }
}

export function scrollNaarAnker(hash, { maxMs = 4000, stapMs = 50 } = {}) {
  const id = idUitHash(hash);
  if (!id) return () => {};
  let timer = null;
  let gestopt = false;
  const start = Date.now();
  let eerste = true;
  const probeer = () => {
    if (gestopt) return;
    const el = document.getElementById(id);
    if (el) {
      // scroll-margin-top op de kop houdt hem onder de vaste navigatiebalk.
      el.scrollIntoView();
      return;
    }
    // Nog niet op de pagina (code laadt nog): eerst naar boven, zoals bij elke nieuwe pagina.
    if (eerste) window.scrollTo(0, 0);
    eerste = false;
    if (Date.now() - start < maxMs) timer = setTimeout(probeer, stapMs);
  };
  probeer();
  return () => {
    gestopt = true;
    if (timer) clearTimeout(timer);
  };
}
